import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

export default function SetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password set. Welcome to CASS HR — please sign in.");
      nav("/login");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[#F8FAFC] p-6" data-testid="set-password-page">
      <div className="w-full max-w-sm">
        <img src="/cass-logo-light.png" alt="CASS" className="h-12 w-auto object-contain mx-auto mb-8" />
        <div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-7">
          <div className="flex items-center gap-2 text-[#2EA3FD] mb-3">
            <CheckCircle2 size={20} />
            <span className="text-xs font-semibold uppercase tracking-wide">You're invited</span>
          </div>
          <h1 className="text-2xl font-extrabold text-[#0B1A2F] font-display">Welcome to CASS HR</h1>
          <p className="text-sm text-slate-500 mt-1 mb-6">Set a password to activate your account, then sign in with your email address.</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="password">Choose a password</Label>
              <Input id="password" data-testid="set-password-input" type="password" required minLength={8}
                value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1"
                placeholder="At least 8 characters" />
            </div>
            {error && <p className="text-sm text-rose-600" data-testid="set-password-error">{error}</p>}
            <Button type="submit" data-testid="set-password-submit-btn" disabled={loading || !token}
              className="w-full bg-[#2EA3FD] hover:bg-[#1B8EE6] text-white font-semibold">
              {loading ? "Saving…" : "Activate account"}
            </Button>
          </form>
        </div>
        <div className="text-center mt-4">
          <Link to="/login" className="text-sm text-[#2EA3FD] hover:underline">Back to sign in</Link>
        </div>
      </div>
    </div>
  );
}
